export default class StreamStation {
    constructor(name, station, media, scheduleEndpoint, assets) {
        this.name = name;
        this.station = station;
        this.media = media;
        this.scheduleEndpoint = scheduleEndpoint;
        this.assets = assets;
    }
}
